import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';

import PhotoSvg from 'eventbrite_design_system/iconography/icons/Photo';
import MoneySvg from 'eventbrite_design_system/iconography/icons/Money';
import GlobeSvg from 'eventbrite_design_system/iconography/icons/Globe';
import ScanCheckSvg from 'eventbrite_design_system/iconography/icons/ScanCheck';
import CreditCardBackSvg from 'eventbrite_design_system/iconography/icons/CreditCardBack';
import LineChartSvg from 'eventbrite_design_system/iconography/icons/LineChart';

// new brand overview page translations
// TODO: Delete duplicate translations

export const TRANSFORM_VISION = lazyGettext(
    'From music festivals and conventions to pop-up dinners and photography classes, transform your vision into an experience people will love.',
);

export const GET_STARTED_MINUTES = lazyGettext('Get started in minutes');
export const CREATE_LISTING = lazyGettext(
    'Create a beautiful event listing page with built-in payment processing, analytics, and support.',
);
export const CHOOSE_SOLUTION = lazyGettext('Choose a solution');
export const GET_STARTED = lazyGettext('Get started');
export const CREATE_AN_EVENT = lazyGettext('Create an event');

export const TAKE_CONTROL = lazyGettext('Take control');
export const TRACK_ANALYTICS = lazyGettext(
    'Manage and track your sales with real time reporting and analytics from any device.',
);
export const ELEVATE_BRAND = lazyGettext('Elevate your brand');
export const PROMOTE_BRAND = lazyGettext(
    'Promote your unique brand with beautifully designed pages that enable easy discovery and ticket purchasing.',
);

export const GATHER_TRIBE = lazyGettext('Gather your tribe');
export const EXTEND_REACH = lazyGettext(
    'Extend your reach and find your audience where they discover experiences on partner sites like Facebook, Instagram and Spotify.',
);

export const MAKE_EXPERIENCE = lazyGettext('Make your event an experience');
export const ONSITE_LOGISTICS = lazyGettext(
    'Give your event goers a great experience with simple, secure checkout and rapid check-in through our mobile apps and a full suite of on-site equipment, staffing, and logistics.',
);
export const RULE_DAYOF = lazyGettext('Rule the day-of');
export const ONSITE_PLANNING = lazyGettext(
    'We can help with on-site planning and consultation. <a href="/contact-sales">Contact us</a> to learn more.',
);

export const GET_STARTED_SOLUTION = lazyGettext(
    'Get started with the perfect solution for your event',
);
export const GET_DETAILS = lazyGettext('Get the details');
export const VIEW_PRICING = lazyGettext('View pricing');

export const PASS_FEES_ON_SECONDARY_HEADER = lazyGettext(
    'Use Eventbrite for free, by passing the fees to your attendees',
);
export const ESSENTIALS_DESCRIPTION = lazyGettext(
    'The solution to start selling tickets quickly and easily',
);
export const PROFESSIONAL_DESCRIPTION = lazyGettext(
    'All features that you need to market your events and grow your business',
);
export const UK_PROFESSIONAL_DESCRIPTION = lazyGettext(
    'A powerful solution to boost sales and grow your business',
);
export const PREMIUM_DESCRIPTION = lazyGettext(
    'Customized solution for large and complex events',
);
export const PRICE_DESCRIPTION = lazyGettext('No fees for free tickets');

// features
const PAYMENT_PROCESSING = lazyGettext('Eventbrite Payment Processing');
const PAID_OUT_QUICK = lazyGettext(
    'Let your attendees pay online, and get paid out quickly.',
);
const FREE_ALWAYS = lazyGettext('Free tickets are always free');
const NO_FEE_FREE = lazyGettext('We never charge fees on free tickets.');
const ORGANIZER_APP = lazyGettext('An app designed for organizers');
const EVENTS_ON_MOBILE = lazyGettext(
    'Run, promote, and track your event from your mobile device.',
);
const OUT_OF_BOX_LISTINGS = lazyGettext(
    'Professional out-of-the-box listing page',
);
const BEAUTIFULLY_DESIGNED_PAGE = lazyGettext(
    'Up your game with a beautifully designed event page.',
);
const EMBED_CHECKOUT = lazyGettext('Embed checkout on your own site');
const EASY_CHECKOUT = lazyGettext(
    'Give your website visitors an easy checkout experience and keep them on your site.',
);
const CUSTOM_BRANDED_SITE = lazyGettext('Create a custom branded website');
const WEB_PRESENCE = lazyGettext(
    'Build your own landing page using our self-service Eventbrite Studio tools.',
);
const MILLIONS_EVENT_GOERS = lazyGettext('Event goers all over the world');
const REACH_MILLIONS = lazyGettext(
    'Three million events in 170+ countries in 2017.',
);
const INDUSTRY_LEADING = lazyGettext('Industry leading search ranking');
const TOP_GOOGLE_SEARCH = lazyGettext(
    'Show up on top of Google search results with our top ranked SEO.',
);
const FB_IG_INTEGRATION = lazyGettext('Facebook and Instagram integration');
const BE_SOCIAL = lazyGettext(
    'Be social and sell tickets on the sites where people love to gather.',
);
const MOBILE_SCANNING = lazyGettext('Easy to use mobile ticket scanning');
const ATTENDEES_FAST = lazyGettext('Get your attendees in the door fast.');
const SELL_MORE_DOOR = lazyGettext('Sell more at the door');
const ACCEPT_MONEY_PRINT_TIX = lazyGettext(
    'Accept credit cards and cash, look up orders, and print tickets.',
);
const FINGER_PULSE = lazyGettext('Keep your finger on the pulse');
const MAKE_DECISIONS = lazyGettext(
    'Make informed decisions with data, insights, and reports.',
);
const EQUIPMENT_RENTALS = lazyGettext('Equipment rentals');
const NEXT_LEVEL = lazyGettext(
    'Take your operations to the next level with mobile box office tech kits.',
);
const STAFFING_LOGISTICS = lazyGettext('Staffing & logistics');
const EXTRA_HANDS = lazyGettext('Put extra hands or a full staff to work.');
const DEDICATED_SUCCESS = lazyGettext('Dedicated success manager');
const EVENT_PRO_BENEFIT = lazyGettext(
    'Benefit from the event expertise of a seasoned pro.',
);

export const PAYMENT_PROCESSING_FEATURE = {
    heading: PAYMENT_PROCESSING,
    description: PAID_OUT_QUICK,
    imagePath: 'overview/img-sm-epp',
};
export const FREE_ALWAYS_FREE_FEATURE = {
    heading: FREE_ALWAYS,
    description: NO_FEE_FREE,
    imagePath: 'overview/img-sm-dance',
};
export const ORGANIZER_APP_FEATURE = {
    heading: ORGANIZER_APP,
    description: EVENTS_ON_MOBILE,
    imagePath: 'overview/img-sm-orgApp',
};
export const LISTING_PAGE_FEATURE = {
    heading: OUT_OF_BOX_LISTINGS,
    description: BEAUTIFULLY_DESIGNED_PAGE,
    iconType: <PhotoSvg />,
    imagePath: 'overview/img-brand-listing',
};
export const CHECKOUT_FEATURE = {
    heading: EMBED_CHECKOUT,
    description: EASY_CHECKOUT,
    iconType: <MoneySvg />,
    imagePath: 'overview/img-brand-checkout',
};
export const CUSTOM_SITE_FEATURE = {
    heading: CUSTOM_BRANDED_SITE,
    description: WEB_PRESENCE,
    iconType: <GlobeSvg />,
    imagePath: 'overview/img-brand-checkout',
};
export const MILLIONS_FEATURE = {
    heading: MILLIONS_EVENT_GOERS,
    description: REACH_MILLIONS,
    imagePath: 'overview/img-sm-millions',
};
export const LEADING_SEARCH_FEATURE = {
    heading: INDUSTRY_LEADING,
    description: TOP_GOOGLE_SEARCH,
    imagePath: 'overview/img-sm-google',
};
export const INTEGRATION_FEATURE = {
    heading: FB_IG_INTEGRATION,
    description: BE_SOCIAL,
    imagePath: 'overview/img-sm-facebook',
};

export const MOBILE_FEATURE = {
    heading: MOBILE_SCANNING,
    description: ATTENDEES_FAST,
    iconType: <ScanCheckSvg />,
};
export const SELL_FEATURE = {
    heading: SELL_MORE_DOOR,
    description: ACCEPT_MONEY_PRINT_TIX,
    iconType: <CreditCardBackSvg />,
};
export const DECISION_MAKING_FEATURE = {
    heading: FINGER_PULSE,
    description: MAKE_DECISIONS,
    iconType: <LineChartSvg />,
};

export const EQUIPMENT_RENTALS_FEATURE = {
    heading: EQUIPMENT_RENTALS,
    description: NEXT_LEVEL,
    imagePath: 'overview/img-onsite-equipment',
};
export const STAFFING_FEATURE = {
    heading: STAFFING_LOGISTICS,
    description: EXTRA_HANDS,
    imagePath: 'overview/img-onsite-staff',
};
export const MANAGER_FEATURE = {
    heading: DEDICATED_SUCCESS,
    description: EVENT_PRO_BENEFIT,
    imagePath: 'overview/img-onsite-manager',
};
